import api from ".";
import {
  AgriPoolInvestmentByInvestor,
  SaveAgriPoolRequest,
} from "../modules/blockchain/types";
import { AgriPoolInvestorTx } from "../modules/invest/types/agri-pool-investor-tx.type";
import { Address, AgriPool, Paginated, PaginationQuery } from "../types";

export const agriPoolApi = {
  checkAgriPoolDuplicate: async (
    model: Pick<
      SaveAgriPoolRequest,
      "id" | "name" | "year" | "harvestTokenAddress"
    >
  ): Promise<void> => {
    return api.post("/agri-pools/check-duplicate", model);
  },
  saveAgriPool: async (model: SaveAgriPoolRequest): Promise<AgriPool> => {
    return (await api.post("/agri-pools", model)).data;
  },
  publishAgriPool: async (id: AgriPool["id"]): Promise<AgriPool> => {
    return (await api.patch(`/agri-pools/${id}/publish`)).data;
  },
  getAgriPools: (params?: PaginationQuery): Promise<Paginated<AgriPool>> => {
    return api.get("/agri-pools", {
      params,
    });
  },
  deleteAgriPool: (id: AgriPool["id"]): Promise<void> => {
    return api.delete(`/agri-pools/${id}`);
  },
  getAgriPool: async (id: AgriPool["id"]): Promise<AgriPool> => {
    return (await api.get(`/agri-pools/${id}`)).data;
  },
  getAgriPoolInvestors: async (
    id: AgriPool["id"]
  ): Promise<AgriPoolInvestmentByInvestor[]> => {
    return (await api.get(`/agri-pools/${id}/investors`)).data;
  },
  getAgriPoolInvestorTxs: async (
    id: AgriPool["id"],
    investor: Address
  ): Promise<AgriPoolInvestorTx[]> => {
    return (await api.get(`/agri-pools/${id}/investors/${investor}`)).data;
  },
};
